import Billing from './Billing.container';

export default Billing;
